import { render, staticRenderFns } from "./TrackDetail.vue?vue&type=template&id=513f0094&scoped=true"
import script from "./TrackDetail.vue?vue&type=script&lang=js"
export * from "./TrackDetail.vue?vue&type=script&lang=js"
import style0 from "./TrackDetail.vue?vue&type=style&index=0&id=513f0094&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f0094",
  null
  
)

export default component.exports